import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-base text-background-50"></i>
              </div>
              <span className="text-base font-bold text-foreground-950">韩国漫画网</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              汇聚热门韩国漫画，支持韩漫在线免费阅读。每日更新，为您提供最佳阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="/category/all">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">分类浏览</Link></li>
              <li><Link to="/category/completed" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">已完结作品</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/romance" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">恋爱韩漫</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">奇幻韩漫</Link></li>
              <li><Link to="/category/action" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">动作韩漫</Link></li>
              <li><Link to="/category/thriller" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">悬疑韩漫</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              联系方式
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-sm"></i>
                <span>contact@koreanmanhwa.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-customer-service-line text-sm"></i>
                <span>在线客服 9:00-18:00</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line text-sm"></i>
                <span>首尔特别市江南区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩国漫画网. 本站内容仅供学习交流使用，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <a href="/about" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="/about" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}